












































import { Component, Prop, Vue } from 'vue-property-decorator';
import NavBar from '../../components/NavBar.vue';
import TabBar from '../../components/TabBar.vue';
import Button from '../../components/Button.vue';
import Booking from '@/types/taxcard/Booking';
import { Action, Getter, namespace } from 'vuex-class';
import Loader from '@/components/Loader.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';
import BIObject from '@/types/taxcard/BIObject';
import VueSignaturePad from 'vue-signature-pad';
import TextField from '@/components/form/TextField.vue';
import CheckboxField from '@/components/form/CheckboxField.vue';
import { GuestTypesEnum } from '@/types/taxcard/GuestType';

const BookingModule = namespace('booking');

@Component({
  components: {
    TextField,
    NewTranslation,
    NavBar,
    TabBar,
    Button,
    Loader,
    VueSignaturePad,
    CheckboxField,
  },
})
export default class BookingRegistrationFormView extends Vue {
  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  @BookingModule.Getter
  public currentBooking!: Booking;

  @BookingModule.Getter
  public currentOrderId!: any;

  @Getter
  public loggedInUser!: any;

  @Action
  public saveRegistrationForm!: any;

  @BookingModule.Mutation
  private setCurrentBooking!: any;

  @BookingModule.Mutation
  private setCurrentPriceProjection!: any;

  @BookingModule.Mutation
  private setCurrentOrderId!: any;

  public openTaxcardIndex: number | null = null;

  public isLoading: boolean = false;

  public passportNumber: string = '';

  public acceptedTerms: boolean = false;

  private mounted(): void {
    if (!this.currentBooking || !this.currentBooking.bIObjects || this.currentBooking.bIObjects.length === 0) {
      this.$router.push({ name: 'transactionOverview' });
      return;
    }
    this.$trackEvent('checkout', 'registration-form', 'entered');
    this.$store.commit('openOverlay', {
      overlayName: 'RegistrationFormConfirm',
    });
  }

  private get qualifiedTaxcards(): BIObject[] {
    // return this.currentBooking.taxcards.filter(t => !t.isAnonymous && t.accommodationId && t.accommodationId !== '');
    const user = this.loggedInUser;
    const taxcards = this.currentBooking.bIObjects.filter(t => t.bIObjectData.guestType === GuestTypesEnum.overnight);
    if (!user) {
      return [taxcards[0]];
    }

    const usersTaxcard = taxcards.find(t => t.bIObjectData.firstName === user.firstName && t.bIObjectData.lastName === user.lastName);
    return [usersTaxcard || taxcards[0]];
  }

  private toggleOpen(index: number): void {
    if (index === this.openTaxcardIndex) {
      this.openTaxcardIndex = null;
    } else {
      this.openTaxcardIndex = index;
    }
  }

  private clearSignature(index: number): void {
    const signatureKey = `signature-${index}`;
    (this.$refs[signatureKey] as any)[0].clearSignature();
  }

  private async submit(): Promise<void> {
    if (!this.acceptedTerms) {
      return;
    }

    const { isEmpty, data } = (this.$refs['signature-0'] as any)[0].saveSignature();

    if (isEmpty) {
      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: {
          title: i18next.t('booking.registrationForm.dialog.error.signature.title'),
          message: i18next.t('booking.registrationForm.dialog.error.signature.body'),
        },
      });
      return;
    }

    this.isLoading = true;
    try {
      await this.saveRegistrationForm({
        signature: isEmpty ? null : data,
        passportNumber: this.passportNumber,
        orderId: this.currentOrderId,
      });

      this.$trackEvent('checkout', 'registration-form', 'success');

      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: {
          submit: () => {
            this.$router.push({ name: 'transactionOverview', params: { purchaseSuccess: 'true' } });
          },
          title: i18next.t('booking.registrationForm.dialog.success.title'),
          message: i18next.t('booking.registrationForm.dialog.success.body'),
        },
      });
    } catch (e) {
      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: {
          submit: () => {
            this.$router.push({ name: 'transactionOverview' });
          },
          title: i18next.t('booking.registrationForm.dialog.failed.title'),
          message: i18next.t('booking.registrationForm.dialog.failed.body'),
        },
      });
    } finally {
      this.isLoading = false;
    }
  }

  private resetBookingData(): void {
    this.setCurrentBooking(null);
    this.setCurrentPriceProjection(null);
    this.setCurrentOrderId(null);
  }

  private beforeDestroy(): void {
    this.resetBookingData();
  }
}
